import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export default function LanguagePrompt() {
  const { i18n } = useTranslation();
  const [visible, setVisible] = useState(() => {
    // Show only if user hasn't selected a language before
    return !localStorage.getItem("cb_lang");
  });

  if (!visible) return null;

  const select = (lang) => {
    localStorage.setItem("cb_lang", lang);
    i18n.changeLanguage(lang);
    setVisible(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" />
      <div className="relative bg-card border border-border/50 shadow-2xl rounded-lg w-full max-w-sm p-8 z-10">
        <div className="text-center mb-8">
          <Globe className="h-8 w-8 text-volt mx-auto mb-4" />
          <h2 className="font-heading text-xl tracking-tight text-foreground mb-2">
            Choose your language
          </h2>
          <p className="text-muted-foreground/60 text-xs tracking-wider uppercase font-semibold">
            اختر لغتك
          </p>
        </div>
        <div className="space-y-3">
          <button
            onClick={() => select("en")}
            className="w-full flex items-center gap-4 px-5 py-4 rounded-lg border border-border/40 bg-background/50 hover:border-volt/50 hover:bg-background transition-all group"
          >
            <span className="text-2xl">🇬🇧</span>
            <div className="text-left">
              <div className="text-sm font-semibold text-foreground/90 group-hover:text-volt transition-colors">English</div>
              <div className="text-[10px] text-muted-foreground/50 tracking-wider uppercase">English</div>
            </div>
          </button>
          <button
            onClick={() => select("ar")}
            className="w-full flex items-center gap-4 px-5 py-4 rounded-lg border border-border/40 bg-background/50 hover:border-volt/50 hover:bg-background transition-all group"
          >
            <span className="text-2xl">🇸🇦</span>
            <div className="text-left">
              <div className="text-sm font-semibold text-foreground/90 group-hover:text-volt transition-colors">العربية</div>
              <div className="text-[10px] text-muted-foreground/50 tracking-wider uppercase">Arabic</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
